<template>
  <span
    v-if="!images.length"
    class="text-uppercase grey--text"
  >Фото</span>
  <v-menu
    v-else
    v-model="imgMenu"
    offset-y
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <span
        class="text-uppercase grey--text text--darken-4 font-weight-bold link"
        v-on="on"
      >Фото
      </span>
    </template>
    <v-list v-if="images.length > 0">
      <v-list-tile
        v-for="img in images"
        :key="img.id"
        class="clickable-row"
      >
        <v-menu
          open-on-hover
          offset-x
        >
          <template v-slot:activator="{ on }">
            <v-list-tile-content v-on="on">
              <v-list-tile-title v-text="img.originName" />
            </v-list-tile-content>
          </template>
          <div
            class="d-flex transition-easy-in-easy-out"
            style="width:200px"
          >
            <v-img :src="img && img.path ? `http://${img.path}` : ''" />
          </div>
        </v-menu>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  props: ["images", "scrollValue"],
  data() {
    return {
      imgMenu: false,
    };
  },
  watch: {
    scrollValue() {
      if (!this.scrollValue) {
        return;
      }
      closeActivList(this.$children[0]);

      function closeActivList(value) {
        if (!value) {
          return;
        }
        if (value.isActive) {
          value.isActive = false;
        }
        if (value.$children) {
          value.$children.forEach(v => closeActivList(v));
        }
      }
    },
  },
};
</script>
